// extracted by mini-css-extract-plugin
export default {"container":"Sidebar_container__OuTmu","title":"Sidebar_title__URLvN","navs":"Sidebar_navs__HR-RO","nav":"Sidebar_nav__30VsF","nav--active":"Sidebar_nav--active__RQInT"};